<label class="esf-form-item__label">{{ label }}
  <app-optional *ngIf="optional"></app-optional>
</label>
<ng-select
  class="esf-form-item__field esf-select__field"
  [formControl]="formControl"
  [items]="multiselectData"
  [multiple]="true"
  [closeOnSelect]="false"
  [hideSelected]="true"
  [clearSearchOnAdd]="true"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue">
</ng-select>
